import { includes } from "lodash";
import { combineEpics } from "redux-observable";
import history from "@ane/core/lib/CreateHistory";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { setSearchContext } from "./actions.js";
import { ACTION_TYPES } from "./constants.js";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { featureSearchContextParams } from "./types.js";
import { selectFeatureSearchContext } from "./selectors.js";
const produceFeatureSearchRouteQueryStringSyncEpics = (history2) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    featureSearchContextParams,
    setSearchContext,
    ACTION_TYPES.SET_PARTIAL_CONTEXT,
    ACTION_TYPES.SET_CONTEXT,
    // todo: we need to pass in a func that allows us to "find" the user context in the store
    // to be more of a plugin, this method should not "know" this, but rather be passed in
    // this would allow this to be used in the context of an app-module, and its hosting app
    selectFeatureSearchContext,
    history2,
    (pathname) => {
      return includes(["/feature-search"], pathname);
    },
    EXP_QUERY_STRINGS
  );
  return combineEpics(...Object.values(setUserContextFromRouteQueryString));
};
const rootEpic = combineEpics(produceFeatureSearchRouteQueryStringSyncEpics(history));
export {
  rootEpic
};
//# sourceMappingURL=epics.js.map
